(function () {
  angular
    .module("akitabox.ui.dialogs.document.archive")
    .controller(
      "ArchiveDocumentDialogController",
      ArchiveDocumentDialogController
    );

  /* @ngInject */
  function ArchiveDocumentDialogController(
    // Angular
    $q,
    // Material
    $mdDialog,
    // Services
    ToastService,
    DocumentService
  ) {
    var self = this;

    // Attributes
    self.saving = false;
    // have to set default false in order to run tests since documents is passed in through locals
    self.multiple = self.documents ? self.documents.length > 1 : false;

    // Functions
    self.cancel = $mdDialog.cancel;
    self.archive = archive;

    // ------------------------
    //   Public Functions
    // ------------------------

    /**
     * Archive documents
     */
    function archive() {
      self.saving = true;
      self.determinateValue = 0;
      var increment = (1 / self.documents.length) * 100;
      var promiseArray = [];

      // Archive the documents
      for (var i = 0; i < self.documents.length; i++) {
        promiseArray[i] = DocumentService.archive(
          self.documents[i].building,
          self.documents[i]._id
        ).then(function (archivedDocument) {
          self.determinateValue += increment;
          return archivedDocument._id;
        });
      }

      $q.all(promiseArray)
        .then(function (archivedDocumentIDs) {
          $mdDialog.hide(archivedDocumentIDs);
        })
        .catch(ToastService.showError)
        .finally(function () {
          self.saving = false;
        });
    }
  }
})();
